<template>
	<div class="pageRoot">
		<h1>Error Tracker Administration Homepage</h1>
		<p>Please select a menu item above.</p>
	</div>
</template>

<script>

	export default {
		components: { },
		data()
		{
			return {
			};
		}
	}
</script>

<style scoped>
	.pageRoot
	{
		margin: 8px;
	}
</style>